export default function genererCritereRechercheProduitReseauTempo() {
  return {
    auto: '',
    actif: true,
    societeId: null,
    reference: null,
    villes: [],
    departements: [],
    formats: [],
    typeReseauIds: [],
    libelle: null,
    dateVisualisation: new Date(),
    agencesId: [],
    inclureConfreres: false,
    secteurIds: [],
    hasSecteur: null,
    exclureVilles: [],
    categories: [],
  };
}
